import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import VariableForm from "components/variables/VariableForm";
import { updateVariable } from "graphql/mutations";
import { getVariable } from "graphql/queries";

const VariableUpdateForm = ({ variableId, onSuccess }) => {
  const navigate = useNavigate();
  const [variable, setVariable] = useState();

  async function onSubmit(values) {
    try {
      const { name, description, shortName, unit, derived, groupType, type } =
        values;

      await API.graphql({
        query: updateVariable.replaceAll("__typename", ""),
        variables: {
          input: {
            id: variableId,
            name,
            description,
            shortName,
            unit,
            derived,
            groupType,
            type,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/variables");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchVariable(id) {
    try {
      const variableData = await API.graphql(
        graphqlOperation(getVariable, { id })
      );
      const variableItem = variableData.data.getVariable;
      if (!variableItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/variables");
        return;
      }
      setVariable(variableItem);
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchVariable(variableId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variableId]);

  if (!variable) return <Loader />;

  return (
    <div>
      <VariableForm
        onSubmit={onSubmit}
        type="update"
        initialValues={variable}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Variable",
    successUpdated: "Variable actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la variable",
    },
  },
});

export default VariableUpdateForm;
